module.exports = __webpack_public_path__ + "static/media/1fca1f72ac91ff736f3ff93ad1cb555f.85b29e0a.png";